import React from 'react'

interface AuthToken {
  jwt: string
}

const authToken = React.createContext<AuthToken>({ jwt: null }) // Create a context object

export default authToken // Export it so it can be used by other Components
